import api from './axios';

export const paymentsAPI = {
  initiatePayment: async (data) => {
    const response = await api.post('/payments/initiate', data);
    return response.data;
  },

  getPaymentStatus: async (paymentId) => {
    const response = await api.get(`/payments/status/${paymentId}`);
    return response.data;
  },

  getPaymentHistory: async (params = {}) => {
    const response = await api.get('/payments/history', { params });
    return response.data;
  },

  completeBookingPayment: async (paymentId) => {
    const response = await api.post(`/payments/complete-booking/${paymentId}`);
    return response.data;
  },

  getBalance: async (providerId) => {
    const response = await api.get('/payouts/balance', { params: { providerId } });
    return response.data;
  },

  requestWithdrawal: async (data) => {
    const response = await api.post('/payouts/withdraw', data);
    return response.data;
  },

  getPayoutHistory: async (providerId) => {
    const response = await api.get('/payouts/history', { params: { providerId } });
    return response.data;
  },

  initiateRegistrationFee: async ({ email, phone, method, plan }) => {
    const response = await api.post('/payments/registration-fee', { email, phone, method, plan });
    return response.data;
  },

  getRegistrationFeeStatus: async (email) => {
    const response = await api.get('/payments/registration-fee/status', { params: { email } });
    return response.data;
  },

  cancelRegistrationFee: async (email) => {
    const response = await api.delete('/payments/registration-fee', { params: { email } });
    return response.data;
  },

  verifyPhone: async (phone) => {
    const response = await api.post('/payments/verify-phone', { phone }, { silent: true });
    return response.data; // { valid: boolean, message?: string }
  },
};
